export const JOB_STATUS = [
    {name: 'All', value: ''},
    {name: 'Pending', value: 'pending'},
    {name: 'Processing', value: 'processing'},
    {name: 'Done', value: 'done'},
    {name: 'Failed', value: 'failed'},
    {name: 'Cancelled', value: 'cancelled'},
]

export const JOB_SHIPPING_CARRIER = [
    {name: 'All', value: ''},
    {name: 'Royal Mail', value: 'royal_mail'},
    {name: 'Singapore Post', value: 'singapore_post'},
    {name: 'TimUS', value: 'timus'},
    {name: 'UPS', value: 'ups_uk'},
    {name: 'USPS MN', value: 'usps_mn'},
    {name: 'Daily Design', value: 'dailydesign'},
    {name: 'LLC_manual', value: 'flashship_usps_manual'},
    {name: 'DPD UK', value: 'dpd_uk'},
    {name: 'SB CA', value: 'sb_ca'},
    {name: 'SB AU', value: 'sb_au'},
    {name: 'SB-YUN', value: 'sb_yun_express'},
    {name: 'HW_USPS', value: 'hw_usps'},
    {name: 'JT_USPS', value: 'jt_usps'},
    {name: 'NS_USPS', value: 'ns_usps'},
    {name: 'ITC Standard', value: 'ge_dhl'},
    {name: 'ITC SPX', value: 'itc_spx'},
    {name: 'ITC GOFO', value: 'itc_gofo'},
]